import React from 'react';

function FeatureCards() {
  const features = [
    {
      id: 1,
      title: "Digital Marketing",
      description: "Comprehensive digital marketing strategies that drive growth and maximize your online presence.",
      image: "https://images.unsplash.com/photo-1562577309-2592ab84b1bc?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3MjgyNzB8MHwxfHNlYXJjaHwxfHxkaWdpdGFsJTIwbWFya2V0aW5nfGVufDB8fHx8MTc0OTA0MDEyM3ww&ixlib=rb-4.1.0&q=80&w=1080",
      attribution: { name: "Merakist", url: "https://unsplash.com/@merakist?utm_source=makerdevi&utm_medium=referral" }
    },
    {
      id: 2,
      title: "Web Development",
      description: "Custom web applications built with modern technologies and best practices for optimal performance.",
      video: "https://v3.fal.media/files/lion/gtc5UXX2i1TgQB7eAOAcK_output.mp4",
      attribution: { name: "Farzad", url: "https://unsplash.com/@euwars?utm_source=makerdevi&utm_medium=referral" }
    },
    {
      id: 3,
      title: "Innovation Technology",
      description: "Cutting-edge technology solutions that push the boundaries of what's possible in your industry.",
      image: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3MjgyNzB8MHwxfHNlYXJjaHwxfHxpbm5vdmF0aW9uJTIwdGVjaG5vbG9neXxlbnwwfHx8fDE3NDkwNDAxMjV8MA&ixlib=rb-4.1.0&q=80&w=1080",
      attribution: { name: "ThisisEngineering", url: "https://unsplash.com/@thisisengineering?utm_source=makerdevi&utm_medium=referral" }
    }
  ];

  return (
    <div className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Services</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We offer comprehensive solutions to help your business thrive in the digital landscape
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature) => (
            <div key={feature.id} className="group relative bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="relative h-64 overflow-hidden">
                {feature.video ? (
                  <video 
                    src={feature.video} 
                    autoPlay
                    loop
                    muted
                    playsInline
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                ) : (
                  <img 
                    src={feature.image} 
                    alt={feature.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                
                {/* Image Attribution */}
                <span className="group/attribution absolute bottom-2 right-2 text-[10px] text-white outline outline-1 outline-white px-[6px] rounded-lg z-10 min-w-4 max-w-[calc(100%-16px)] h-4 leading-4 truncate text-center shadow">
                  <span className="block drop-shadow-md group-hover/attribution:hidden">i</span>
                  <span className="hidden drop-shadow-md group-hover/attribution:block">
                    Image on{' '}
                    <a
                      href="https://unsplash.com?utm_source=Maker%20AI&utm_medium=referral"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: '#fff', textDecoration: 'none' }}
                    >
                      Unsplash
                    </a>{' '}
                    by{' '}
                    <a
                      href={feature.attribution.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: '#fff', textDecoration: 'none' }}
                    >
                      {feature.attribution.name}
                    </a>
                  </span>
                </span>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-3">{feature.title}</h3>
                <p className="text-gray-600 mb-4">{feature.description}</p>
                <button className="text-green-600 hover:text-green-800 font-medium transition-colors duration-200">
                  Learn More →
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default FeatureCards;